export default "__VITE_ASSET__454f9895__"